import { render, staticRenderFns } from "./ContainerWidgetItem.vue?vue&type=template&id=3e2e890e&scoped=true"
import script from "./ContainerWidgetItem.vue?vue&type=script&lang=js"
export * from "./ContainerWidgetItem.vue?vue&type=script&lang=js"
import style0 from "./ContainerWidgetItem.vue?vue&type=style&index=0&id=3e2e890e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2e890e",
  null
  
)

export default component.exports